<template>
  <div class="parameters">
    <HeadLine>
      {{$ml.get('parameters')}}
    </HeadLine>
    <table class="th-table">
      <tr class="head">
        <td>{{$ml.get('Layer Depth')}}</td>
        <td>{{$ml.get('Bulk density')}}</td>
        <td>{{$ml.get('EC')}}</td>
        <td>{{$ml.get('pH')}}</td>
        <td>{{$ml.get('OM')}}</td>
        <td>{{$ml.get('CEC')}}</td>
        <td>{{$ml.get('Avg. Temperature')}}</td>
      </tr>
      <tr>
        <td>{{ section.data.layer_depth }} {{$ml.get('cm')}}</td>
        <td>{{ section.data.bulk }} {{$ml.get('ton/m3')}}</td>
        <td>{{ section.data.ec }} {{$ml.get('dS/m')}} </td>
        <td>{{ section.data.ph }}</td>
        <td>{{ section.data.om }}%</td>
        <td>{{ section.data.cec }} {{$ml.get('meq/100g')}} </td>
        <td>{{ section.data.avg_temp }} °C</td>
      </tr>
    </table>
  </div>
</template>

<script>
import HeadLine from './../common/HeadLine';

export default {
  computed: {
    section() {
      return this.$root.data.soilTest;
    }
  },
  components: {
    HeadLine,
  },
}
</script>

<style lang="scss" scoped>

.parameters {
  table {
    padding-top: 10px;
    margin-bottom: 10px;
    border: 0;
    td {
      padding: 5px 0;
      &:first-child {
        text-align: center;
      }
    }
  }
}

</style>